module.exports = __webpack_public_path__ + "static/media/heads-up.fc192048.jpg";